import * as CL from '@design-system/component-library';
import * as React from 'react';
import { type Ref, forwardRef } from 'react';
import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';
import { preventSubmit } from '../../common/utils/handlerUtils';
import { Input } from '../Input/Input.js';
import type { InputProps } from '../Input/Input.js';

interface CloseButtonProps {
  onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <button
    onClick={onClick}
    className={dsClass.INPUT_INPUTAREA_CLEAR}
    title={t.DW0G('Clear the field')}
    aria-label={t.DW0G('Clear the field')}
    type="button"
    style={{
      top: 0,
      transform: 'none',
    }}
  >
    <CL.Icon icon="close" size="s" type="filled" />
  </button>
);

interface InputSearchProps extends InputProps {
  noSubmit?: boolean; // Prevents enter key from causing form submission.
}

export const InputSearch = forwardRef((props: InputSearchProps, ref: Ref<HTMLInputElement>) => {
  const { name, onKeyDown, noSubmit, ...rest } = props;

  return (
    <Input
      {...rest}
      ref={ref}
      name={name || 'search'}
      type="search"
      style={{ paddingLeft: '48px' }}
      onKeyDown={onKeyDown ?? (noSubmit ? preventSubmit : undefined)}
    >
      <span
        style={{
          height: '24px',
          left: 0,
          padding: '12px 8px 12px 17px',
          position: 'absolute',
          top: 0,
          width: '24px',
          pointerEvents: 'none',
          boxSizing: 'content-box',
        }}
      >
        <CL.Icon icon="search" size="m" />
      </span>
      {props.children}
    </Input>
  );
});
